(function () {
  function createExternalVideoIframe(type, id) {
    if (!type || !id) {
      return null;
    }

    var iframe = document.createElement('iframe');

    iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('title', 'Promo video');

    if (type === 'youtube') {
      iframe.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&playsinline=1&rel=0';
    }

    if (type === 'vimeo') {
      iframe.src =
        'https://player.vimeo.com/video/' + id + '?autoplay=1&title=0&byline=0&portrait=0';
    }

    if (!iframe.src) {
      return null;
    }

    return iframe;
  }

  function initLandingPromoVideo(container) {
    if (!container) {
      return;
    }

    var player = container.querySelector('[data-landing-promo-video-player]');
    var playButton = container.querySelector('[data-landing-promo-video-play]');

    if (!player || !playButton) {
      return;
    }

    playButton.addEventListener('click', function () {
      var nativeVideo = player.querySelector('video');
      var iframeWrap = player.querySelector('[data-landing-promo-video-iframe]');
      var videoType = player.getAttribute('data-video-type');
      var videoId = player.getAttribute('data-video-id');

      player.classList.add('is-playing');

      if (nativeVideo) {
        nativeVideo.play();
        return;
      }

      if (!iframeWrap || iframeWrap.querySelector('iframe')) {
        return;
      }

      var iframe = createExternalVideoIframe(videoType, videoId);

      if (iframe) {
        iframeWrap.appendChild(iframe);
      }
    });
  }

  function initAllLandingPromoVideos() {
    document.querySelectorAll('[data-landing-promo-video]').forEach(function (container) {
      initLandingPromoVideo(container);
    });
  }

  document.addEventListener('DOMContentLoaded', initAllLandingPromoVideos);

  document.addEventListener('shopify:section:load', function (event) {
    initLandingPromoVideo(event.target.querySelector('[data-landing-promo-video]'));
  });
})();
